export default __webpack_public_path__ + "static/media/free-trial.9dc6b584.webp";